import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import {
  SpiritoryWebEndpoints,
} from '@/types/api/api-v2';

export default async function doSetNotificationsAsReaded() {
  try {
    const { data } = await spiritoryWebApi.patch(
      `/set-notifications-readed` as SpiritoryWebEndpoints,
      undefined,
      undefined
    );

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
